import { inject, observer } from "mobx-react";

import Default from "./Default";

import { useAbTestComponent } from "@utils";

const abTests = {
    dev_1635: () => import("./AB_1635"), //15/01/26 еще не запущен
};

const FormTemplate = inject("mainStore")(
    observer(({ mainStore, ...props }) => {
        const init = mainStore.getMainStore("init");
        const Specified = useAbTestComponent({ init, abTests, defaultComponent: Default, matchValue: "v2" });

        return <Specified {...props} />;
    }),
);

export default FormTemplate;
